/**
 * Created by ZhangJunPeng on 2017/5/22.
 */

import React from 'react';
import moment from 'moment';
import { defineMessages } from 'react-intl';
import MeetingRoom from './MeetingRoom';
import TimeTable from './TimeTable';
import ReservationDialog from '../commons/ReservationDialog';
import PromptInfo from '../../utils/promptInfo';
import PropTypes from 'prop-types';

const DialogType = PromptInfo.DialogType;

const messages = defineMessages({
  end: {
    id: 'search_page_end'
  },
  weekFormat: {
    id: 'time_format_week'
  }
});

class WeekView extends React.Component {
  _timeMap = new Map();
  _length = 7;

  constructor(props) {
    super(props);
    this.makeTimeTitle = this.makeTimeTitle.bind(this);
    this.makeMeetingRoom = this.makeMeetingRoom.bind(this);
    this.handleNextPage = this.handleNextPage.bind(this);
    this.handlePrevPage = this.handlePrevPage.bind(this);
    this.scrollEnd = this.scrollEnd.bind(this);
  }

  makeTimeTitle() {
    const { showTime, intl } = this.props;
    const begin = moment(showTime);
    let titleDiv = new Array(this._length + 1);
    begin.day(-1);
    // 第一个为为会议室Header，内容为空
    titleDiv.push(<li key={-1} />);
    for (let i = 0; i < this._length; i++) {
      begin.add(1, 'days');
      this._timeMap.set(i, moment(begin));
      titleDiv.push(
        <li key={i} style={{ textAlign: 'center' }}>
          <span>
            {begin.format('M/D') +
              ' ' +
              begin.format(intl.formatMessage(messages.weekFormat))}
          </span>
        </li>
      );
    }
    return titleDiv;
  }

  makeMeetingRoom() {
    const { searchResults, intl, dispatch, meetingPolicy } = this.props;
    let roomDiv = [];
    let timeTable = [];
    searchResults.list.forEach(v => {
      roomDiv.push(
        <MeetingRoom
          from={'WeekView'}
          room={v}
          key={v.id + '_room'}
          intl={intl}
          dispatch={dispatch}
          meetingPolicy={meetingPolicy}
        />
      );
      timeTable.push(
        <TimeTable
          {...this.props}
          room={v}
          days={this._length}
          timeMap={this._timeMap}
          key={v.id + '_div'}
        />
      );
    });
    return { roomDiv, timeTable };
  }

  handleNextPage() {
    const { dispatch, searchResults, timeType } = this.props;
    if (searchResults.pageNo < searchResults.pageCount) {
      dispatch({
        type: 'meeting/getCalenderData',
        filter: { type: timeType, pageNo: searchResults.pageNo + 1 }
      });
    } else {
      this.scrollEnd();
    }
  }

  handlePrevPage() {
    const { dispatch, searchResults, timeType } = this.props;
    if (searchResults.pageNo > 1) {
      dispatch({
        type: 'meeting/getCalenderData',
        filter: { type: timeType, pageNo: searchResults.pageNo - 1 }
      });
    } else {
      this.scrollEnd();
    }
  }

  scrollEnd() {
    const { intl, locale } = this.props;
    ReservationDialog({
      type: DialogType.INFORMATION,
      message: intl.formatMessage(messages.end),
      locale: locale
    });
  }

  componentDidUpdate() {
    let offsetWidth = document.getElementsByClassName('week-calendar-area')[0]
      .offsetWidth;
    let scrollWidth = document.getElementsByClassName('week-calendar-area')[0]
      .scrollWidth;
    let offset =
      offsetWidth - scrollWidth > 0 ? offsetWidth - scrollWidth - 1 : 0;
    document.getElementsByClassName(
      'week-calendar-title'
    )[0].style.paddingRight = offset + 'px';
    let weekCalendarHeight = document.body.clientHeight - 190;
    document.getElementsByClassName('week-calendar-area')[0].style.maxHeight =
      weekCalendarHeight + 'px';
  }

  componentDidMount() {
    let offsetWidth = document.getElementsByClassName('week-calendar-area')[0]
      .offsetWidth;
    let scrollWidth = document.getElementsByClassName('week-calendar-area')[0]
      .scrollWidth;
    let offset =
      offsetWidth - scrollWidth > 0 ? offsetWidth - scrollWidth - 1 : 0;
    document.getElementsByClassName(
      'week-calendar-title'
    )[0].style.paddingRight = offset + 'px';
    let weekCalendarHeight = document.body.clientHeight - 190;
    document.getElementsByClassName('week-calendar-area')[0].style.maxHeight =
      weekCalendarHeight + 'px';
  }

  render() {
    const { searchResults } = this.props;
    const { roomDiv, timeTable } = this.makeMeetingRoom();
    return (
      <div className="table">
        <ul className="week-calendar-title table-right-div table-right-div-week ul1">
          {this.makeTimeTitle()}
        </ul>
        <div
          className="week-calendar-area"
          style={{ maxHeight: '590px', overflowY: 'auto' }}
        >
          <div className="table-left" ref={c => (this._left = c)}>
            {searchResults.pageNo > 1 && (
              <div className="table-up">
                <i className="iconfont icon-up" onClick={this.handlePrevPage} />
              </div>
            )}
            <div className="roomDiv">{roomDiv}</div>
            {searchResults.pageNo < searchResults.pageCount && (
              <div className="table-down">
                <i
                  className="iconfont icon-down"
                  onClick={this.handleNextPage}
                />
              </div>
            )}
          </div>
          <div className="table-right" ref={c => (this._right = c)}>
            <div>{timeTable}</div>
          </div>
        </div>
      </div>
    );
  }
}

WeekView.propTypes = {
  viewType: PropTypes.oneOf(['week']).isRequired,
  timeType: PropTypes.oneOf([2, 3]).isRequired,
  searchResults: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  showTime: PropTypes.object.isRequired
};

export default WeekView;



// WEBPACK FOOTER //
// ./src/components/meeting/WeekView.js